import { Component, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EaccessAuthService } from '../auth/eaccess-auth.service';
import { AccountsService } from '../accounts/accounts.service';
import { NGXLogger } from 'ngx-logger';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, map, tap } from 'rxjs';
import { UsersService } from '../users/users.service';
import { CigpStaffService } from '../cigp-staff/cigp-staff.service';
import { omit } from 'lodash-es';

@Component({
  selector: 'eaa-landing',
  imports: [MatProgressSpinnerModule],
  template: `
    @if (loggedIn) {
      <div class="d-flex flex-column gap-4">
        <div class="d-flex justify-content-center align-items-center gap-3">
          <p class="m-0"><i> Loading accounts...</i></p>
          @if (loadingAccounts) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            <i class="bi bi-check-lg text-success"></i>
          }
        </div>
        <div class="d-flex justify-content-center align-items-center gap-3">
          <p class="m-0"><i> Loading users...</i></p>
          @if (loadingUsers) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            <i class="bi bi-check-lg text-success"></i>
          }
        </div>
        <div class="d-flex justify-content-center align-items-center gap-3">
          <p class="m-0"><i> Loading staffs...</i></p>
          @if (loadingStaffs) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            <i class="bi bi-check-lg text-success"></i>
          }
        </div>
      </div>
    }
  `
})
export class LandingComponent implements OnInit {
  public loadingAccounts = true;
  public loadingStaffs = true;
  public loadingUsers = true;
  public loggedIn = false;

  constructor(
    private authService: EaccessAuthService,
    private router: Router,
    private accountsService: AccountsService,
    private usersService: UsersService,
    private cigpStaffService: CigpStaffService,
    private logger: NGXLogger,
    private route: ActivatedRoute
  ) {}

  public ngOnInit(): void {
    this.authService.loggedIn$.subscribe((loggedIn) => (this.loggedIn = loggedIn));

    combineLatest([
      this.accountsService.accountsSet$.pipe(tap((accountsSet) => (this.loadingAccounts = !accountsSet))),
      this.usersService.usersSet$.pipe(tap((usersSet) => (this.loadingUsers = !usersSet))),
      this.cigpStaffService.staffsSet$.pipe(tap((staffsSet) => (this.loadingStaffs = !staffsSet)))
    ])
      .pipe(map(([accountsSet, usersSet, staffsSet]) => accountsSet && usersSet && staffsSet))
      .subscribe((ready) => {
        if (ready) {
          this.logger.log('System is now ready', this.route);
          setTimeout(() => {
            const path = this.route.snapshot.queryParamMap.get('origin') || '/home';
            const remainingParams = omit(this.route.snapshot.queryParams, ['origin']);
            this.router.navigate([path], { queryParams: remainingParams });
          }, 250);
        }
      });
  }

  public login(): void {
    this.authService.login$().subscribe();
  }
}
